/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./audio-controller.vue?vue&type=template&id=22b8a1fa&scoped=true&"
import script from "./audio-controller.vue?vue&type=script&lang=js&"
export * from "./audio-controller.vue?vue&type=script&lang=js&"
import style0 from "./audio-controller.vue?vue&type=style&index=0&id=22b8a1fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b8a1fa",
  null
  
)

export default component.exports